import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import StarRating from "@/components/base/StarRating";

interface MovieCardProps {
  movie: Movie;
  variant?: "grid" | "list";
}

export default function MovieCard({ movie, variant = "grid" }: MovieCardProps) {
  if (variant === "list") {
    return (
      <Link
        to={`/detail/${movie.id}`}
        className="group flex gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors duration-200 hover:border-primary-300 hover:bg-primary-50/50 md:p-4"
      >
        <div className="h-[150px] w-[100px] shrink-0 overflow-hidden rounded-md bg-background-200 md:h-[168px] md:w-[112px]">
          <img
            src={movie.cover}
            alt={`${movie.title} 海报`}
            title={`${movie.title} - 韩国三级电影`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex items-start justify-between gap-2">
            <h3 className="truncate text-base font-bold text-foreground-950 group-hover:text-primary-600 md:text-lg">
              {movie.title}
            </h3>
            <span className="shrink-0 whitespace-nowrap text-xs text-foreground-500">{movie.year}</span>
          </div>
          <div className="mt-1">
            <StarRating rating={movie.rating} />
          </div>
          <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600 md:line-clamp-3">
            {movie.synopsis}
          </p>
          <div className="mt-auto flex flex-wrap items-center gap-2 pt-3">
            {movie.genres.slice(0, 3).map((g) => (
              <span
                key={g}
                className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
              >
                {g}
              </span>
            ))}
            <span className="ml-auto whitespace-nowrap text-xs text-foreground-400">
              <i className="ri-eye-line mr-1" aria-hidden="true" />
              {movie.views.toLocaleString()}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-200 hover:border-primary-300"
    >
      <div className="aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 韩国三级电影`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate text-sm font-bold text-foreground-950 group-hover:text-primary-600">
          {movie.title}
        </h3>
        <div className="mt-1 flex items-center justify-between">
          <StarRating rating={movie.rating} />
          <span className="text-xs text-foreground-400">{movie.year}</span>
        </div>
        <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">{movie.synopsis}</p>
      </div>
    </Link>
  );
}